import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useParams,
} from "react-router-dom";

import Home from "./pages/Home";
import VersionPage from "./pages/VersionPage";
import Header from "./components/Header";
import { SearchProvider, useSearch } from "./context/SearchContext";
import AboutPage from "./pages/AboutPage";
import GrowPage from "./pages/GrowPage"; // ✅

const HeaderWrapper = () => {
  const location = useLocation();
  const { versionId } = useParams();
  const { query, setQuery } = useSearch();

  let title = "";
  let showSubtitle = false;
  let hideSearchBar = false;

  const isHomePage = location.pathname === "/";

  if (isHomePage) {
    title = "My AOL Disk Collection";
    showSubtitle = true;
  } else if (location.pathname.startsWith("/version/") && versionId) {
    title =
      versionId === "unknown"
        ? "Unknown Version Disks"
        : `Version ${versionId} Disks`;
  } else if (location.pathname === "/about") {
    title = "About AOL Collecting";
    hideSearchBar = true;       // hide search
    showSubtitle = false;       // hide subtitle
  } else if (location.pathname === "/grow-the-collection") {
    title = "Grow The Collection!";
    hideSearchBar = true;       // hide search
    showSubtitle = false;       // hide subtitle
  }

  return (
    <Header
      title={title}
      showSubtitle={showSubtitle}
      showBackButton={!isHomePage}
      query={query}
      setQuery={setQuery}
      hideSearchBar={hideSearchBar}
    />
  );
};

function App() {
  return (
    <SearchProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HeaderWrapper />
                <Home />
              </>
            }
          />
          <Route
            path="/version/:versionId"
            element={
              <>
                <HeaderWrapper />
                <VersionPage />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <HeaderWrapper />
                <AboutPage />
              </>
            }
          />
          <Route
            path="/grow-the-collection"
            element={
              <>
                <HeaderWrapper />
                <GrowPage />
              </>
            }
          />
        </Routes>
      </Router>
    </SearchProvider>
  );
}

export default App;
